import React from "react";
var __jsx = React.createElement;
import loadable from "@loadable/component";
import Layout from "@/_LayoutsRelated/layout/Layout";
import UnbxdPosts from "../../components/SearchComponent/UnbxdComponents/UnbxdPosts/UnbxdPosts";
import stl from "./Filters.module.css";
import SpecsSection from "../../components/SearchComponent/UnbxdComponents/SpecsSection/SpecsSection";
import useFilterPage, { useSearchResultsData } from "@/pages/search/searchHooks/useSearchAndFilters";
var fallback = {
  fallback: null
};
var UnbxdAsideFilters = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-SearchComponent-UnbxdComponents-UnbxdAsideFilters-UnbxdAsideFilters";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-SearchComponent-UnbxdComponents-UnbxdAsideFilters-UnbxdAsideFilters" */"../../components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/UnbxdAsideFilters");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../../components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/UnbxdAsideFilters");
    }
    return eval('require.resolve')("../../components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/UnbxdAsideFilters");
  }
}, fallback);
var Unbxd = function Unbxd() {
  var _useFilterPage = useFilterPage(),
    isLoading = _useFilterPage.isLoading,
    searchResults = _useFilterPage.searchResults,
    sort = _useFilterPage.sort,
    searchTerm = _useFilterPage.searchTerm,
    setShowFilters = _useFilterPage.setShowFilters,
    showFilters = _useFilterPage.showFilters,
    isAutosPage = _useFilterPage.isAutosPage,
    isYearsPage = _useFilterPage.isYearsPage;
  var _useSearchResultsData = useSearchResultsData(),
    filters = _useSearchResultsData.filters,
    selectedOptions = _useSearchResultsData.selectedOptions,
    dealFacet = _useSearchResultsData.dealFacet,
    specs = _useSearchResultsData.specs,
    sortOptions = _useSearchResultsData.sortOptions,
    metaData = _useSearchResultsData.metaData;
  return /*#__PURE__*/React.createElement(Layout, {
    hideBannerCssOnly: true,
    hasNavBar: true,
    pageName: "search",
    searchSearchHeader: true,
    headHideLinks: true,
    disableLoader: true,
    hideHeaderOnmobile: true,
    showSearchBar: true
    // ={!isLoading}
  }, /*#__PURE__*/React.createElement("section", {
    className: [stl.searchPageContainer, "container", "extraWideContainer", isLoading ? isLoading : "",
    //todo is it a bug? isLoading is a boolean
    stl.NewContainer].join(" ")
  }, /*#__PURE__*/React.createElement(UnbxdAsideFilters, {
    filters: filters,
    selectedOptions: selectedOptions,
    sort: sort,
    sortOptions: sortOptions,
    loading: isLoading,
    showFilters: showFilters,
    setShowFilters: setShowFilters,
    dealFacet: dealFacet,
    postsCount: metaData === null || metaData === void 0 ? void 0 : metaData.productsCount,
    searchTerm: searchTerm,
    metaData: metaData
  }), /*#__PURE__*/React.createElement(UnbxdPosts, null)), /*#__PURE__*/React.createElement(SpecsSection, {
    selectedOptions: selectedOptions,
    isAutos: isAutosPage || isYearsPage,
    specs: specs
  }));
};
export default Unbxd;